import { render, staticRenderFns } from "./ScheduleCohort.vue?vue&type=template&id=18504214"
import script from "./ScheduleCohort.vue?vue&type=script&lang=js"
export * from "./ScheduleCohort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports